module.exports = __webpack_public_path__ + "img/banner2.85acad81.png";